import { render, staticRenderFns } from "./offerimage.vue?vue&type=template&id=77f21b60&scoped=true&"
import script from "./offerimage.vue?vue&type=script&lang=js&"
export * from "./offerimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f21b60",
  null
  
)

export default component.exports